import { Rule, RuleGroup, RuleGroupShort } from "@/types/rule.types.ts";

export interface ApiApprovalPolicy {
  id: number;
  title: string;
  category: ApiApprovalCategoryType;
  flow_processing_type: ApiApprovalPolicyType;
  flow_type: ApprovalPolicyFlowType;
  flow_skip: boolean;
  flow_rules: Rule[];
  assign_to_groups?: RuleGroup[] | null;
  assign_to?: Rule[] | null;
  substitution_enabled: boolean;
  substitution_type: ApprovalPolicySubstitutionType | null;
  substitution_rule: Rule | null;
  time_off_category_ids: number[];
  employees_count?: number;
}

export type ApiApprovalPolicyPayload = Omit<
  ApiApprovalPolicy,
  "id" | "category" | "assign_to" | "assign_to_groups"
> & {
  category_id: number;
  assign_to_groups: RuleGroupShort[];
};

export function getApprovalPolicyAssignToGroups(policy: ApiApprovalPolicy): RuleGroup[] {
  if (policy.assign_to_groups != null) return policy.assign_to_groups;
  const rules = policy.assign_to ?? [];
  return rules.length > 0 ? [{ rules }] : [];
}

export enum ApiApprovalCategoryType {
  time_off = "time_off",
  compensation = "compensation",
  hiring_plan = "hiring_plan",
  offer = "offer",

  custom = "custom",
}

export enum ApiApprovalPolicyType {
  full = "full",
  any = "any",
}

export enum ApprovalPolicyFlowType {
  sequence_approval = "sequence_approval",
  parallel_approval = "parallel_approval",
}

export enum ApprovalPolicySubstitutionType {
  skip = "skip",
  transfer = "transfer",
}
